<div class="flex items-center justify-between gap-3 mb-4 px-2">
  <h1 class="text-lg sm:text-xl font-bold text-[#0B0D5C] truncate">
  {{ 'DEMOGRAPHIC.ADD_NEW_LEAD' | translate }}
</h1>
  <app-back-button></app-back-button>
</div>

<section class="bg-white rounded-xl border border-gray-200 p-6">
  <!-- Header (ONE ROW, GLOBAL STYLE) -->
  <div class="flex items-center justify-between gap-3 mb-6">
    <h2 class="text-base sm:text-lg font-semibold text-slate-900 truncate">
  {{ 'DEMOGRAPHIC.TITLE' | translate }}
</h2>

    <button
      *ngIf="isRelationshipOfficer"
      type="button"
      class="flex-shrink-0 px-5 py-2 rounded-xl border border-indigo-600 text-indigo-600 text-sm font-medium hover:bg-indigo-50 whitespace-nowrap"
      (click)="openCreateFromEmail()"
    >
{{ 'DEMOGRAPHIC.CREATE_FROM_EMAIL' | translate }}    </button>
  </div>

  <!-- Form -->
  <app-dynamic-form
    [fields]="fields"
    (formSubmit)="onFormSubmit($event)"
    (formChange)="onFormChange($event)"
  >
    >
  </app-dynamic-form>

  <!-- Actions -->
  <!-- Actions -->
<div class="flex gap-4 mt-8">
  <button
    *ngIf="isRelationshipOfficer"
    type="button"
    (click)="submitForm()"
    class="px-8 py-3 rounded-xl bg-secondary text-white font-medium hover:bg-indigo-600"
  >
   {{ isEditMode ? ('DEMOGRAPHIC.UPDATE' | translate) : ('DEMOGRAPHIC.SAVE' | translate) }}
  </button>

  <!-- ✅ ADD -->
  <button
    *ngIf="leadSeq"
    type="button"
    (click)="saveAndContinue()"
    class="px-8 py-3 rounded-xl bg-indigo-600 text-white font-medium hover:bg-indigo-700"
  >
   {{ 'DEMOGRAPHIC.CONTINUE' | translate }}
  </button>
</div>
</section>

@if (showCreateFromEmail) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50"   *ngIf="!isViewMode"
>
    <div class="bg-white rounded-2xl w-[90%] max-w-2xl p-8 relative">

      <!-- Close -->
      <button
        type="button"
        (click)="closeCreateFromEmail()"
        class="absolute top-6 end-6 w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100"
      >
        ✕
      </button>

      <!-- Title -->
      <h2 class="text-xl font-semibold text-[#151D48] mb-6">
       {{ 'DEMOGRAPHIC.CREATE_FROM_EMAIL' | translate }}
      </h2>

      <!-- TEXTAREA (REPLACED FILE UPLOAD) -->
      <textarea
        [(ngModel)]="emailText"
        rows="8"
       [placeholder]="'DEMOGRAPHIC.PASTE_EMAIL_CONTENT' | translate"
        class="w-full border border-gray-300 rounded-xl p-4 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 mb-6"
      ></textarea>

      <!-- Actions -->
      <div class="flex gap-6">
        <button
          type="button"
          (click)="emailLeadExtraction()"
          class="px-8 py-2 rounded-xl bg-secondary text-white font-medium text-lg"
        >
         {{ 'DEMOGRAPHIC.EXTRACT' | translate }}
        </button>

        <button
          type="button"
          (click)="closeCreateFromEmail()"
          class="px-8 py-2 rounded-xl bg-cancel text-white font-medium text-lg"
        >
         {{ 'DEMOGRAPHIC.CANCEL' | translate }}
        </button>
      </div>

    </div>
  </div>
}
